import type {ContentRelationshipField, GroupField, KeyTextField} from '@prismicio/client'
import {isFilled} from '@prismicio/client'
import type {ButtonDocument, CustomerStoryDocument} from 'prismicio-types'

export * from './config'
export * from './extractTextSegments'
export * from './prismicLink'
export * from './toError'
export * from './track'
export * from './useTypewriter'
export * from './videoMimeType'
export * from './wrong-uids'

export const getIconName = (name: string) => {
  if (typeof name !== 'string') {
    return ''
  }

  return name?.toLowerCase().replace(/ /g, '-')
}

export const getButtonsData = ({
  buttonsData,
  primaryButton,
  secondaryButton,
}: {
  buttonsData?: ButtonDocument[]
  primaryButton?: ContentRelationshipField
  secondaryButton?: ContentRelationshipField
}) => {
  const primaryButtonDocId = isFilled.contentRelationship(primaryButton) ? primaryButton.id : null
  const secondaryButtonDocId = isFilled.contentRelationship(secondaryButton) ? secondaryButton.id : null

  const primaryButtonData = buttonsData?.find((button) => button.id === primaryButtonDocId)?.data ?? null
  const secondaryButtonData = buttonsData?.find((button) => button.id === secondaryButtonDocId)?.data ?? null

  return {
    primaryButtonData,
    secondaryButtonData,
  }
}

export const getCustomerStoryData = ({
  customerStoriesData,
  customer,
}: {
  customerStoriesData?: CustomerStoryDocument[]
  customer?: ContentRelationshipField
}) => {
  const customerDocId = isFilled.contentRelationship(customer) ? customer.id : null

  return customerStoriesData?.find((story) => story.id === customerDocId)?.data ?? null
}

export const getPersonalisedContent = <T extends {utm_term?: KeyTextField}>(
  group: GroupField<T>,
  term: string,
): T | null => {
  if (!group || !isFilled.group(group)) {
    return null
  }

  const item = group.find((element) => element.utm_term === term)
  return item ? item || '' : group[0] || ''
}

export const safeParse = <T>(value: string | null): T | null => {
  if (!value) {
    return null
  }

  try {
    return JSON.parse(value) as T
    // eslint-disable-next-line @typescript-eslint/no-unused-vars -- Catches any parsing errors
  } catch (e) {
    return null
  }
}

export const encodeQueryParam = (value: string): string => {
  if (!value || typeof value !== 'string') {
    return ''
  }

  return encodeURIComponent(value)
}
